// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getSystemList, SystemListApiParameter, SystemListModel } from "@tps/App/Services/SystemListService";

type HandlerType = ApiHandler<SystemListApiParameter, SystemListModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { name: props.parameter.name };
};

export const DispatchBeginLoadSystemList: HandlerType = (props: any) => {
    props.dispatch({
        type: "xSystemLists/isLoadingLoadSystemList",
        isLoading: true,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getSystemList(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xSystemLists/isLoadingLoadSystemList",
            isLoading: false,
        } as any);

        return error.errorMessage;
    }
};

export const DispatchCompleteLoadSystemList: HandlerType = (props: any) => {
    props.dispatch({
        type: "xSystemLists/CompleteLoadSystemList",
        systemList: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadSystemList,
    RequestDataFromApi,
    DispatchCompleteLoadSystemList,
];

const loadSystemList = createHandlerChainRunner(chain, "LoadSystemList");
export default loadSystemList;
